import React, { useState } from 'react';
import DefaultAvatar from './DefaultAvatar';

const UserAvatar = ({ 
  user, 
  size = 'medium', 
  className = '',
  showOnlineStatus = false 
}) => {
  const [imageError, setImageError] = useState(false);

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  // Get the user's name (checking different possible properties)
  const userName = user?.fullName || user?.name || 'Unknown User';
  const profilePicture = user?.profilePicture;

  // Size mappings for the img element
  const imageSizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-20 h-20',
    xlarge: 'w-32 h-32'
  };

  const imageSize = imageSizeClasses[size] || imageSizeClasses.medium;

  // Show default avatar if no profile picture or if image failed to load
  if (!profilePicture || imageError) {
    return (
      <div className="relative inline-block">
        <DefaultAvatar name={userName} size={size} className={className} />
        {showOnlineStatus && (
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
        )}
      </div>
    );
  }

  return (
    <div className="relative inline-block">
      <img
        src={profilePicture}
        alt={userName}
        onError={handleImageError}
        className={`${imageSize} rounded-full object-cover ${className}`}
      />
      {showOnlineStatus && (
        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
      )}
    </div>
  );
};

export default UserAvatar;